import { Component, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';

import { Subscription } from 'rxjs';

import { AppState } from '../../../../../state';
import { selectSelectedIntervention } from '../../../../state/intervention/intervention.selectors';
import { selectDevices } from '../../../../state/device/device.selectors';
import { Device } from '../../../../../models/device';
import { Intervention } from '../../../../../models/intervention';

@Component({
  selector: 'dashboard-session-files',
  templateUrl: './session-files.component.html',
  styleUrls: ['./session-files.component.scss'],
})
export class SessionFilesComponent implements OnInit {
  selectedIntervention: Intervention;
  devices: Device[];

  private subscription = new Subscription();

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.subscription.add(
      this.store.select(selectSelectedIntervention).subscribe((intervention) => {
        this.selectedIntervention = intervention;
      })
    );
    this.subscription.add(
      this.store.select(selectDevices).subscribe((devices) => {
        this.devices = devices;
      })
    );
  }

  goToMetricsDownloadSection() {
    // TODO: navigate to metrics download section
  }
}
